import React from 'react';

interface IOverageFees {
  tableOpen: boolean;
  setTableOpen: any;
}

const OverageFees: React.FC<IOverageFees> = ({ tableOpen, setTableOpen }) => {
  const toggleTable = () => {
    setTableOpen((prev: boolean) => !prev);
  };

  return (
    <>
      <div id='overage-notice-container'>
        <div className='overage-notice-text'>
          *After reaching your monthly search/upload limit, the following overage pricing applies per additional search/upload:
        </div>
      </div>
      <div className='overage-fees-container'>
        <div className='overage-fees-content'>
          <div className='overage-fees-table'>
            <div className='overage-fees-table-header'>
              <div className='overage-fees-table-header-content'>
                <div className='overage-fees-table-header-text-group'>
                  <div className='overage-fees-table-header-text-frame'>
                    <div className='overage-fees-table-header-title'>
                      Overage Fees
                    </div>
                    <div className='overage-fees-table-toggle' onClick={toggleTable}>
                      <div className='overage-fees-table-toggle-text'>
                        {tableOpen ? 'Hide' : 'Show'} Table
                      </div>
                      {tableOpen ? (
                        <div className='overage-fees-table-toggle-icon'>
                          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                            <path d='M6 9L12 15L18 9' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                          </svg>
                        </div>
                      ) : (
                        <div className='overage-fees-table-toggle-icon'>
                          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                            <path d='M15 6L9 12L15 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                          </svg>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {tableOpen && (
              <div className='overage-fees-table-body'>
                <div className='overage-fees-table-column'>
                  <div className='overage-fees-column-header'>
                    <div className='overage-fees-column-header-cell'>
                      <div className='overage-fees-column-header-cell-text'>
                        Screening Type
                      </div>
                    </div>
                  </div>
                  <div className='overage-fees-row-cell'>
                    <div className='overage-fees-row-cell-text-group'>
                      <div className='overage-fees-row-cell-text-primary'>
                        People/Companies
                      </div>
                    </div>
                  </div>
                  <div className='overage-fees-row-cell'>
                    <div className='overage-fees-row-cell-text-group'>
                      <div className='overage-fees-row-cell-text-primary'>
                        Products/Commodities
                      </div>
                    </div>
                  </div>
                  <div className='overage-fees-row-cell' style={{ border: 'none' }}>
                    <div className='overage-fees-row-cell-text-group'>
                      <div className='overage-fees-row-cell-text-primary'>
                        Supplier/Custom Forms
                      </div>
                    </div>
                  </div>
                </div>
                <div className='overage-fees-table-column'>
                  <div className='overage-fees-column-header'>
                    <div className='overage-fees-column-header-cell'>
                      <div className='overage-fees-column-header-cell-text'>
                        Price per Search / Upload
                      </div>
                    </div>
                  </div>
                  <div className='overage-fees-row-cell'>
                    <div className='overage-fees-row-cell-text-group'>
                      <div className='overage-fees-row-cell-text-secondary'>
                        $0.05 /search
                      </div>
                    </div>
                  </div>
                  <div className='overage-fees-row-cell'>
                    <div className='overage-fees-row-cell-text-group'>
                      <div className='overage-fees-row-cell-text-secondary'>
                        $0.15 /search
                      </div>
                    </div>
                  </div>
                  <div className='overage-fees-row-cell' style={{ border: 'none' }}>
                    <div className='overage-fees-row-cell-text-group'>
                      <div className='overage-fees-row-cell-text-secondary'>
                        $0.90 /upload
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OverageFees;
